import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "item"];

  connect() {
    if (this.slideTarget && this.itemTarget) {
      const itemWidth = this.itemTarget.offsetWidth;
      const viewportWidth = window.innerWidth;

      // ビューポートを埋めるために必要なコピー数（最低1つ）
      const copies = Math.max(1, Math.ceil(viewportWidth / itemWidth));

      for (let i = 0; i < copies; i++) {
        const clone = this.itemTarget.cloneNode(true);
        this.slideTarget.appendChild(clone);
      }

      this.slideTarget.style.setProperty("--scroll-distance", `-${itemWidth}px`);
    }
  }
}
